export const SOCKET_COMMANDS = {
  PAYMENT: (saleId: number) =>  `sale-${saleId}`,
};
